import { useDispatch, useSelector } from 'react-redux';
import { useGetCompaniesFilteredQuery } from '../../../store/api/backoffice/backofficeApi';
import TableGrid, { Column, Row } from './TableGrid';
import { RootState } from '../../../store/store';
import React, { useEffect, useState } from 'react';
import { changeFilters } from '../../../store/slices/backoffice/backofficeCompaniesSlice';

function TesteGrid() {
  const backofficeCompanies = useSelector(
    (state: RootState) => state.backofficeCompanies,
  );
  const {
    data: backofficeCompaniesRawData,
    isFetching,
    refetch,
  } = useGetCompaniesFilteredQuery(backofficeCompanies.filters);
  const [rows, setRows] = useState<Row[]>([]);
  const dispatch = useDispatch();

  const columns: Column[] = [
    { name: 'Nome da Empresa', sortable: true, sortName: 'CompanyName' },
    { name: 'ID', sortable: true, sortName: 'CompanyDatabaseId' },
    { name: 'Motoristas', sortable: false, sortName: 'DriversCount' },
  ];

  //set the rows to the data from the query
  useEffect(() => {
    const rows: Row[] =
      backofficeCompaniesRawData?.itemList?.map((item: any) => ({
        id: item.companyDatabaseId,
        cells: [
          { value: item.companyName },
          { value: item.companyDatabaseId },
          { value: item.driversCount },
        ],
      })) ?? [];
    setRows(rows);
  }, [backofficeCompaniesRawData]);

  //refetch the data when the filters change
  useEffect(() => {
    refetch();
  }, [backofficeCompanies?.filters]);

  const handleSort = (column: string, ascending: boolean) => {
    dispatch(
      changeFilters({
        ...backofficeCompanies.filters,
        orderByColumn: column,
        ascending: ascending,
      }),
    );
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    dispatch(
      changeFilters({
        ...backofficeCompanies.filters,
        currentPage: newPage + 1,
      }),
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(
      changeFilters({
        ...backofficeCompanies.filters,
        pageSize: parseInt(event.target.value),
        currentPage: 1,
      }),
    );
  };

  const handleRowClick = (item: Row, event: React.MouseEvent) => {
    throw new Error('Function not implemented.');
  };

  return (
    <TableGrid
      columns={columns}
      rows={rows}
      isLoading={isFetching}
      orderByColumn={backofficeCompanies.filters.orderByColumn}
      ascending={backofficeCompanies.filters.ascending}
      onSort={handleSort}
      showPagination={true}
      totalResults={backofficeCompaniesRawData?.totalResults}
      pageSize={backofficeCompanies?.filters?.pageSize || 15}
      currentPage={backofficeCompanies?.filters?.currentPage || 1}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      routerLink={'/companies'}
      onRowClick={handleRowClick}
    />
  );
}

export default TesteGrid;
